/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { Component, Input, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslationService } from 'src/common/translation.service';
import { DialogConfig } from '../types';

/**
 * Reusable component that displays the buttons for standard aero dialogs.
 */
@Component({
  selector: 'aero-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrls: ['./dialog-footer.component.scss'],
  standalone: false,
})
export class DialogFooterComponent implements OnInit {

  @Input() public config: DialogConfig;

  @Input() public dialogRef: DynamicDialogRef;

  @Input() public primaryDisabled: boolean;

  @Input() public secondaryDisabled: boolean;

  constructor(private $translate : TranslationService) { }

  ngOnInit(): void {
    // Translate and set the default secondary button label if one isn't provided.
    if (!this.config.secondaryLabel) {
      this.config.secondaryLabel = this.$translate.translateInstant('button_cancel');
    }
  }

  /**
   * Handler for when the primary button is clicked.
   */
  onPrimary(): void {
    if (this.config.onPrimary) {
      this.config.onPrimary(this.dialogRef);
    }
    if (this.config.closable && this.config.closeOnPrimary) {
      this.dialogRef.close();
    }
  }

  /**
   * Handler for when the primary button is clicked.
   */
  onSecondary(): void {
    if (this.config.onSecondary) {
      this.config.onSecondary(this.dialogRef);
    }
    if (this.config.closable && this.config.closeOnSecondary) {
      this.dialogRef.close();
    }
  }
}
